module.exports = __webpack_public_path__ + "static/media/digi_khata_1.54a3a609.webp";